import { render, staticRenderFns } from "./saleDetail.vue?vue&type=template&id=e265f4b0"
import script from "./saleDetail.vue?vue&type=script&lang=js"
export * from "./saleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports